import { StatusBadge } from 'app/concierge/types';
import { Box } from '@mui/material';
import React from 'react';

// The title is text, never markup: it carries the model's requested web address and data-author resource names
// (WebAction.php:130, ProcessModel::learningProgressTitle), and the model can forge a whole badge block (security unit 7).
export default function JsonStatusBadge({ statusBadge }: { statusBadge: StatusBadge }) {
    return <Box>{statusBadge.title}</Box>;
}
